import { ThunkDispatch } from 'redux-thunk'
import { RootState } from 'src/redux/createRootReducer'

import { AgentShortcut } from './agent.reducer'

export const SET_IS_AGENT_OPEN = 'app/SET_IS_AGENT_OPEN'
export interface SetIsAgentOpenAction {
  type: typeof SET_IS_AGENT_OPEN
  payload: {
    isAgentOpen: boolean
  }
}
export const createSetIsAgentOpen = (isAgentOpen: boolean) => {
  return (
    dispatch: ThunkDispatch<RootState, void, SetIsAgentOpenAction>,
  ): void => {
    dispatch({
      type: SET_IS_AGENT_OPEN,
      payload: {
        isAgentOpen,
      },
    })
  }
}

export const SET_AGENT_SHORTCUT = 'app/SET_AGENT_SHORTCUT'

export interface SetAgentShortcutAction {
  type: typeof SET_AGENT_SHORTCUT
  payload: {
    shortcut: AgentShortcut | undefined
  }
}
export const createSetAgentShortcut = (shortcut: AgentShortcut | undefined) => {
  return (
    dispatch: ThunkDispatch<RootState, void, SetAgentShortcutAction>,
  ): void => {
    dispatch({
      type: SET_AGENT_SHORTCUT,
      payload: {
        shortcut,
      },
    })
  }
}
